import React from 'react';

const KEYFRAMES = `@keyframes skPulse{0%,100%{opacity:1}50%{opacity:0.4}}`;

// Single calm pulse — all boxes animate together, same speed, no sweep, no stagger
function Box({ tk, w = '68%', h = 11, r = 5 }) {
  return (
    <div style={{
      width: w,
      height: h,
      borderRadius: r,
      background: tk.borderStrong || tk.border,
      animation: 'skPulse 1.8s ease-in-out infinite',
      flexShrink: 0,
    }} />
  );
}

// ─── Stat strip skeleton ──────────────────────────────────────────────────────

export function StatStripSkeleton({ tk, count = 4 }) {
  return (
    <>
      <style>{KEYFRAMES}</style>
      <div style={{
        display: 'grid',
        gridTemplateColumns: `repeat(${count}, 1fr)`,
        gap: 12,
        marginBottom: 16,
      }}>
        {Array.from({ length: count }).map((_, i) => (
          <div key={i} style={{
            background: tk.surface,
            border: `1px solid ${tk.border}`,
            borderRadius: 12,
            padding: '12px 14px',
          }}>
            <Box tk={tk} w="52%" h={10} />
            <div style={{ marginTop: 10 }}>
              <Box tk={tk} w="38%" h={20} r={4} />
            </div>
            <div style={{ marginTop: 7 }}>
              <Box tk={tk} w="26%" h={9} r={4} />
            </div>
          </div>
        ))}
      </div>
    </>
  );
}

// ─── Table skeleton ───────────────────────────────────────────────────────────
// colWidths: array of flex proportions matching the page's real columns

export function TableSkeleton({ tk, colWidths, rows = 8 }) {
  const cols = colWidths || [1, 3, 2, 1.5, 1];

  return (
    <>
      <style>{KEYFRAMES}</style>
      <div style={{
        background: tk.surface,
        border: `1px solid ${tk.border}`,
        borderRadius: 12,
        overflow: 'hidden',
      }}>
        {/* Header — slightly narrower bars to suggest labels */}
        <div style={{
          display: 'flex',
          alignItems: 'center',
          padding: '10px 16px',
          gap: 8,
          background: tk.surfaceAlt,
          borderBottom: `1px solid ${tk.border}`,
        }}>
          {cols.map((flex, ci) => (
            <div key={ci} style={{ flex, minWidth: 0 }}>
              <Box tk={tk} w="45%" h={9} r={4} />
            </div>
          ))}
        </div>

        {/* Rows — all identical, all pulse together */}
        {Array.from({ length: rows }).map((_, ri) => (
          <div
            key={ri}
            style={{
              display: 'flex',
              alignItems: 'center',
              padding: '11px 16px',
              gap: 8,
              borderBottom: ri < rows - 1 ? `1px solid ${tk.border}` : 'none',
            }}
          >
            {cols.map((flex, ci) => (
              <div key={ci} style={{ flex, minWidth: 0 }}>
                <Box tk={tk} w="68%" h={11} />
              </div>
            ))}
          </div>
        ))}
      </div>
    </>
  );
}
